module.exports = __webpack_public_path__ + "static/media/svalbard-and-jan-mayen.0077495c.svg";